import { Component } from '@angular/core';

@Component({
  selector: 'mwl-text-input-autocomplete-container',
  styles: [
    `
    :host {
      position: relative;
      display: block;
    }
  `
  ],
  template: '<ng-content></ng-content>'
})
export class TextInputAutocompleteContainerComponent {}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/text-input-autocomplete-container.component.ts